import type { PrintPart, SlideEntry } from "./types";

/**
 * The slides one print run renders, each with its index in the whole deck:
 * `main` drops the appendix, `appendix` keeps only it, no part keeps all.
 */
export function slidesForPart(
  slides: SlideEntry[],
  part: PrintPart | undefined
): Array<{ slide: SlideEntry; index: number }> {
  return slides
    .map((slide, index) => ({ slide, index }))
    .filter(({ slide }) =>
      part === "main" ? !slide.appendix : part === "appendix" ? !!slide.appendix : true
    );
}
